import React, { Component } from 'react';
import { X } from 'react-feather';
import PropTypes from 'prop-types';

import AttachmentView from '../AttachmentView/AttachmentViewContainer';

export default class AttachmentModal extends Component {

  static propTypes = {
    history: PropTypes.object,
    attachmentId: PropTypes.string,
  };

  componentDidMount() {
      document.addEventListener('keydown', this.handleKeyboardEvents);
  }

  componentWillUnmount() {
      document.removeEventListener('keydown', this.handleKeyboardEvents);
  }

  /**
   * Handles keyboard events.
   * event.which and event.keyCode properties are deprecated and will be removed from the web standard (see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/which).
   * event.code returns a string representation of the keypressed and is the new web standard, but not all browsers have it implemented so which and keycode are available as a fallback.
   * @param event a keyboard event
   */
  handleKeyboardEvents = event => {
    const key = event.code || event.which || event.keyCode;
    if (key === 'Escape' || key === 27) {
      this.back(event);
    }
  };

  back = event => {
    event.stopPropagation();
    this.props.history.goBack();
  };

  render() {
    const { attachmentId } = this.props;
    return (
      <div className="attachment-modal">
        <button
          onClick={this.back}
          className="modal-close"
        >
          <span><X size={24}/></span>
        </button>
        <div className="modal-content">
          <AttachmentView
            attachmentId={attachmentId}
            isInModal
            onClickOutsideOfAttachment={this.back}
          />
        </div>
      </div>
    );
  }
};
